@if (errors.length) {
  <nb-alert outline="danger">
    @for (err of errors; track err) {
      <p>{{ err }}</p>
    }
  </nb-alert>
}

<form [formGroup]="form" (ngSubmit)="submit()">
  <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>

  <vmspdb-ui-debug [model]="model"></vmspdb-ui-debug>
  <p>
    <button
      type="submit"
      nbButton
      status="primary"
      class="me-1"
      [nbSpinner]="processing"
      [disabled]="form.invalid || processing"
    >
      {{ model.uuid ? 'Clock Out' : 'Start' }}
    </button>
  </p>
</form>
